import { render, staticRenderFns } from "./trade-detail.vue?vue&type=template&id=7a629e53&scoped=true&"
import script from "./trade-detail.vue?vue&type=script&lang=js&"
export * from "./trade-detail.vue?vue&type=script&lang=js&"
import style0 from "./trade-detail.vue?vue&type=style&index=0&id=7a629e53&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a629e53",
  null
  
)

export default component.exports